"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindTreeViewItemDetail = exports.FindTreeviewItem = void 0;
/**
 * Find an item in the treeview data
 * @param uniqueID: The UniqueID property value of the item to find
 * @param data: The data in which to search for the item
 * @returns The item found matching the UniqueID
 */
var FindTreeviewItem = function (uniqueID, data) {
    var found;
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var item = data_1[_i];
        if (!found && item.UniqueID === uniqueID) {
            found = item;
            break;
        }
        else if (!found && item.Children) {
            found = exports.FindTreeviewItem(uniqueID, item.Children);
            if (found) {
                break;
            }
        }
    }
    return found;
};
exports.FindTreeviewItem = FindTreeviewItem;
/**
 * Find an item in the treeview
 * @param uniqueID The uniqueID property value to find
 * @param data the data to find the item in
 * @returns object containing the found info.
 */
var FindTreeViewItemDetail = function (uniqueID, data, parent) {
    if (parent === void 0) { parent = undefined; }
    var found;
    for (var index = 0; index < data.length; index++) {
        var item = data[index];
        if (!found && item.UniqueID === uniqueID) {
            found = {
                Index: index,
                Item: item,
                Parent: parent,
                Siblings: data,
            };
            break;
        }
        else if (!found && item.Children) {
            found = exports.FindTreeViewItemDetail(uniqueID, item.Children, item);
            if (found) {
                break;
            }
        }
    }
    return found;
};
exports.FindTreeViewItemDetail = FindTreeViewItemDetail;
